(() => {
  const init = () => {
    const header = document.querySelector('.section-header');
    const menus = [...document.querySelectorAll('[data-mv3-menu]')];
    const closeMenus = (except) => menus.forEach((menu) => { if (menu !== except) menu.open = false; });
    menus.forEach((menu) => {
      if (menu.dataset.mv3Bound) return;
      menu.dataset.mv3Bound = 'true';
      menu.addEventListener('toggle', () => {
        if (menu.open) closeMenus(menu);
        header?.classList.toggle('mv3-menu-open', menus.some((item) => item.open));
      });
      menu.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        event.stopPropagation();
        menu.open = false;
        menu.querySelector('summary')?.focus();
      });
      menu.addEventListener('focusout', () => requestAnimationFrame(() => {
        if (!menu.contains(document.activeElement)) menu.open = false;
      }));
    });
    if (!document.documentElement.dataset.mv3Bound) {
      document.documentElement.dataset.mv3Bound = 'true';
      document.addEventListener('click', (event) => {
        if (!event.target.closest('[data-mv3-menu]')) document.querySelectorAll('[data-mv3-menu]').forEach((menu) => { menu.open = false; });
      });
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const mobile = document.querySelector('.mobile-category-menu');
        if (mobile?.classList.contains('open')) {
          mobile.classList.remove('open');
          document.body.classList.remove('overflow-hidden');
          const burger = document.querySelector('.header_burger');
          burger?.setAttribute('aria-expanded', 'false');
          burger?.focus();
        }
      });
    }
    const mobile = document.querySelector('.mobile-category-menu');
    const burger = document.querySelector('.header_burger');
    if (mobile && burger && !mobile.dataset.mv3Bound) {
      mobile.dataset.mv3Bound = 'true';
      let originalInert = false;
      let wasOpen = false;
      const main = document.getElementById('MainContent');
      const synchronize = () => {
        const open = mobile.classList.contains('open');
        burger.setAttribute('aria-expanded', String(open));
        mobile.setAttribute('aria-hidden', String(!open));
        if (open && !wasOpen) { originalInert = main?.inert || false; if (main) main.inert = true; }
        if (!open && wasOpen && main) main.inert = originalInert;
        wasOpen = open;
      };
      new MutationObserver(synchronize).observe(mobile, { attributes: true, attributeFilter: ['class'] });
      synchronize();
      mobile.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
        if (wasOpen && main) main.inert = originalInert;
        document.body.classList.remove('overflow-hidden');
      });
      mobile.addEventListener('click', (event) => {
        if (!event.target.closest('a')) return;
        mobile.classList.remove('open');
        document.body.classList.remove('overflow-hidden');
      });
      document.querySelectorAll('.header_place_wrapper a, .search-toggler').forEach((control) => control.addEventListener('click', () => {
        mobile.classList.remove('open');
        document.body.classList.remove('overflow-hidden');
      }));
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', init);
})();

if (!customElements.get('miranda-interface-rail')) {
  customElements.define('miranda-interface-rail', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.mv4-interface-track');
      this.previous = this.querySelector('[data-mv4-prev]');
      this.next = this.querySelector('[data-mv4-next]');
      if (!this.track || !this.previous || !this.next) return;
      this.update = () => {
        const end = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        this.previous.disabled = this.track.scrollLeft <= 1;
        this.next.disabled = this.track.scrollLeft >= end - 1;
        this.querySelector('.mv4-interface-controls').hidden = end <= 1;
      };
      this.move = (direction) => {
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: direction * Math.max(190, this.track.clientWidth * .75), behavior: reduced ? 'auto' : 'smooth' });
      };
      this.goPrevious = () => this.move(-1);
      this.goNext = () => this.move(1);
      this.previous.addEventListener('click', this.goPrevious);
      this.next.addEventListener('click', this.goNext);
      this.track.addEventListener('scroll', this.update, { passive: true });
      this.resize = new ResizeObserver(this.update);
      this.resize.observe(this.track);
      this.update();

      // Keep existing desktop compatibility help visible outside the scroll clip.
      this.helpBindings = [];
      this.querySelectorAll('.mv4-interface-slide').forEach((slide, index) => {
        const trigger = slide.querySelector('.tooltip.desktop');
        const dialog = slide.querySelector('.tooltip_dialog_dk');
        if (!trigger || !dialog) return;
        dialog.id = `${this.track.id}-help-${index}`;
        trigger.setAttribute('aria-controls', dialog.id);
        trigger.setAttribute('aria-expanded', 'false');
        this.append(dialog);
        const close = () => { dialog.style.display = 'none'; trigger.setAttribute('aria-expanded', 'false'); };
        const show = () => {
          dialog.style.display = 'block';
          dialog.style.position = 'fixed';
          dialog.style.margin = '0';
          dialog.style.transform = 'none';
          const origin = trigger.getBoundingClientRect();
          const box = dialog.getBoundingClientRect();
          dialog.style.left = `${Math.max(12, Math.min(innerWidth - box.width - 12, origin.left + origin.width / 2 - box.width / 2))}px`;
          dialog.style.top = `${Math.max(12, Math.min(innerHeight - box.height - 12, origin.bottom + 8))}px`;
          trigger.setAttribute('aria-expanded', 'true');
        };
        const activate = (event) => {
          if (event.type === 'keydown' && !['Enter', ' ', 'Escape'].includes(event.key)) return;
          event.preventDefault();
          event.stopPropagation();
          if (event.key === 'Escape' || trigger.getAttribute('aria-expanded') === 'true') close();
          else show();
        };
        const events = [['mouseenter', show], ['mouseleave', close], ['focus', show], ['blur', close], ['click', activate], ['keydown', activate]];
        events.forEach(([name, callback]) => trigger.addEventListener(name, callback));
        this.helpBindings.push({ trigger, events, close });
      });
    }
    disconnectedCallback() {
      this.previous?.removeEventListener('click', this.goPrevious);
      this.next?.removeEventListener('click', this.goNext);
      this.track?.removeEventListener('scroll', this.update);
      this.resize?.disconnect();
      this.helpBindings?.forEach(({ trigger, events, close }) => {
        events.forEach(([name, callback]) => trigger.removeEventListener(name, callback));
        close();
      });
    }
  });
}
